/**
 * @module geo/functionalities/services
 */
import {Observable} from 'rxjs/Observable';

import {ExecuteSearch} from '../../types/services/execute.search';
import {SearchService} from '../../services/search';
import {ServiceLoader} from '../../services/service.loader';
import {SearchExecutionParameters, SearchFunctionality} from '../search';

import {FunctionalityService} from '.';

/**
 *
 *
 * @since v2.1.0
 */
export class SearchFunctionalityService extends
    FunctionalityService<SearchFunctionality, SearchService> {
  protected functionality: SearchFunctionality;
  protected parentService: SearchService;

  private num: number = 0;
  constructor(functionality: SearchFunctionality, options: any) {
    super();
    this.functionality = functionality;
    this.parentService = ServiceLoader.getServiceInstance(
        'Search', options.store.getState().uid, options);
    this.num = 0;
  }

  /**
   * Execute the search without add it il canvas and return results in an
   * observable object
   *
   * Example :
   * ```
   * geoApp.getFunctionalityById("xxx")
   *  .getService()
   *  .executeSearch({"featureId":15})
   *  .subscribe(
   *      (results)=>{
   *          // doSomething with results
   *      });
   * ```
   */
  public executeSearch(params?: SearchExecutionParameters,      transient?:boolean,   idService?: string):
      Observable<ExecuteSearch> {
    this.num++;
    return this.parentService.executeSearch(
        [this.functionality.asSimpleFunctionality()], params,
        transient,idService);
  }
}